<header obg-app-m-header-container static [titleText]="title$ | async"></header>
<div #content class="obg-m-iframe-layout-content">
	<router-outlet></router-outlet>
	<obg-footer-container *ngIf="!isMfeSbEnabled"></obg-footer-container>
</div>
